// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603041333/js/" + chunkId + "." + {"44":"6de61041","225":"aa69a4f9","481":"c6aea124","486":"a8ea8e81","770":"0910efdb"}[chunkId] + ".0.680979834477766.chunk.js";
};